<!--Copy and paste the code below into
a separate view file.
Add content in v-col component, as described below.-->
<template>
  <!-- Responsive home page layout -->
  <v-app>
    <v-container>
      <v-row justify="center">
        <!-- Navigation Bar -->
        <v-col cols="12" class="mb-8">
          <!-- Implement Back Arrow functionality. Menu disabled.-->
          <NavBar backArrow disableMenu />
        </v-col>
        <!-- Search Bar -->
        <v-col cols="12" class="d-flex justify-end">
          <SearchBar v-model="searchQuery" />
        </v-col>
        <!-- Display content in v-col below.
             If you want multiple columns, side-by-side,
             create more columns and use cols="12" md="6" lg="4"
             or similiar to adjust columns according to breakpoint as
             desired. Look at the responsiveness and source code
             of the Home page as an example -->
        <!-- Filters Section -->
        <v-col cols="12" class="d-flex justify-center">
          <v-card>
            <v-card-title class="title-wrap">Filters</v-card-title>
            <v-card-text>
              <v-row justify="center">
                <v-col cols="6">
                  <!-- General Search -->
                  <v-text-field v-model="searchQuery" label="Search (any keyword)" outlined dense></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- Multi-Select Categories -->
                  <v-select v-model="selectedCategories" :items="categoryOptions" label="Multi-Select Categories"
                    outlined dense multiple></v-select>
                </v-col>
                <v-col cols="12">
                  <!-- Select Disorder -->
                  <v-select v-model="selectedDisorder" :items="disorderOptions" label="Select Disorder" outlined
                    dense></v-select>
                </v-col>
              </v-row>

              <!-- General Search -->
              <v-text-field v-model="searchQuery" label="Search (any keyword)" outlined dense></v-text-field>

              <!-- Apply and Clear Buttons -->
              <v-btn color="primary" @click="applyFilters" block>Apply Filters</v-btn>
              <v-btn color="secondary" @click="clearFilters" block class="mt-2">
                Clear Search
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Main Content Section -->
        <v-col cols="12" class="main-content">
          <v-row>
            <v-col cols="12">
              <v-btn @click="itemCount++">Add</v-btn>
              <v-btn @click="itemCount--">Remove</v-btn>
            </v-col>
            <v-col cols="12">
              <CartBadge :count="itemCount"></CartBadge>
            </v-col>
            <v-col cols="12">
              <SelectionToggle v-model:choice="choice" v-model:name="text">
              </SelectionToggle>
            </v-col>
            <v-col cols="12">
              {{ choice }} : {{ text }}
            </v-col>
            <v-col cols="12">
              <ContentPanel :contents="contents" :contentGroup="categories[text]" @add-selection="addSelection"
                @remove-selection="removeSelection" :selections="selections"></ContentPanel>
              {{ contents }} - {{ categories[text] }}
              {{ selections }}
            </v-col>
            <v-col cols="12" m="6">
              <SelectionToggle></SelectionToggle>
            </v-col>

            <v-col cols="12" m="6">
              <div v-for="(patient, i) in patients" :key="i">
                <PatientPanel :patient="patient"></PatientPanel>
              </div>
            </v-col>

          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
  <!-- Footer -->
  <MENDFooter></MENDFooter>
</template>

<script>
// Imported components present in each page.
import MENDFooter from '../MENDFooter.vue';
import NavBar from '../NavBar.vue';
import CartBadge from './CartBadge.vue';
import SelectionToggle from './SelectionToggle.vue';
import axios from 'axios';
import ContentPanel from './ContentPanel.vue';
import SearchBar from './SearchBar.vue';
import PatientPanel from './PatientPanel.vue';

export default {
  name: 'TestPage',
  data() {
    return {
      itemCount: 0,
      text: "Educational",
      choice: 0,
      contents: [],
      patients: [],
      selections: {},
      searchQuery: {},
      showFavorites: false,
      selectedCategories: [],
      selectedDisorder: null,
      categoryOptions: ["Breathwork", "Gratitude", "Meditation", "Self Talk"],
      disorderOptions: [
        "Anger",
        "Anxiety",
        "Dissociative",
        "Eating",
        "Mood",
        "Neurodevelopmental",
        "Obsessive-Compulsive",
        "Personality",
        "Psychotic",
        "Somatic Symptom",
        "Substance-Related",
        "Trauma",
      ],
      categories: {
        "Educational": "Learning Library"
      }
    }
  },
  components: {
    NavBar,
    MENDFooter,
    CartBadge,
    SelectionToggle,
    ContentPanel,
    SearchBar,
    PatientPanel
  },
  methods: {
    // Rewrite later, in backend
    async fetchData() {
      try {
        axios.defaults.baseURL = process.env.VUE_APP_API_URL;
        const response = await axios.get(`/api/unifiedcontent/categories/${this.categories[this.text]}`);
        this.contents = response.data;
        this.contents = response.data.filter(content =>
          content.toLowerCase().includes(this.searchQuery.toLowerCase()));
        console.log(this.contents);
      } catch (error) {
        console.log(error);
      }
    },
    async fetchPatients(providerId) {
      try {
        axios.defaults.baseURL = process.env.VUE_APP_API_URL;
        const response = await axios.get(`/api/patient/provider/${providerId}`);
        this.patients = response.data;
      } catch (error) {
        console.log(error);
      }

    },
    addSelection(item) {
      this.selections[item.contentId] = item;
    },
    removeSelection(item) {
      delete this.selections[item.contentId];
    },
    applyFilters() {
      let filtered = [...this.contents];
      if (this.showFavorites) {
        filtered = filtered.filter((content) => content.isFavorite);
      }
      if (this.selectedCategories.length > 0) {
        filtered = filtered.filter((content) =>
          this.selectedCategories.includes(content.category)
        );
      }
      if (this.selectedDisorder) {
        filtered = filtered.filter(
          (content) => content.disorder === this.selectedDisorder
        );
      }
      if (this.searchQuery) {
        filtered = filtered.filter((content) =>
          content.title.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
      }
      this.filteredContents = filtered;
    },
    clearFilters() {
      this.searchQuery = "";
      this.showFavorites = false;
      this.selectedCategories = [];
      this.selectedDisorder = null;
      this.applyFilters();
    },
  },
  mounted() {
    this.fetchData();
    this.fetchPatients("b3ebee3c-cd2f-47df-8ef7-d7a1873d5c12");
  },
}
</script>

<style>
* {
  font-family: 'Montserrat';
}

.filters-box {
  position: fixed;
  top: 80px;
  left: 20px;
  width: 250px;
  z-index: 10;
  background-color: white;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  border-radius: 8px;
}

.main-content {
  margin-left: 280px;
  padding: 20px;
}

.flex-box {
  display: flex;
  justify-content: center;
}
</style>
